import image1 from "../assets/birthdance2025/day-1.png";
import image2 from "../assets/birthdance2025/day-2.png"
import image3 from "../assets/birthdance2025/day-3.png"
import image4 from "../assets/birthdance2025/day-4.png"
import image5 from "../assets/birthdance2025/day-5.png"
import image6 from "../assets/birthdance2025/day-6.png"

const birth2025 = [

  {
    title: "Birthdance47",
    subtitle: "at NOYA / Very Limited Capacity. Please reserve +38346772777",
    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit...",
    image: image1,
    mediaType: "image",
    date: "19.02.2025 Friday",
    textColor: "#FF5454",
    route: "/birthdance/day-1",
  },
  {
    title: "Birthdance47",
    subtitle: "MAIN EVENT at ZONE CLUB",
    content: "Pellentesque habitant morbi tristique senectus et netus...",
    image: image2,
    mediaType: "image",
    date: "02.03.2024 Saturday",
    textColor: "#06D04F",
    route: "/birthdance/day-2",
  },
  {
    title: "Birthdance47",
    subtitle: 'EDHE the LAST DANCE with Family',
    content: "Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    image: image3,
    mediaType: 'image',
    date: '03.03.2024 Sunday',
    day: 'HEALTHY FOOD, ART, YOGA...',
    textColor: '#7C6DE7',
    route: "/birthdance/day-3",
  },
  {
    title: "Birthdance47",
    subtitle: 'EDHE the LAST DANCE with Family',
    content: "Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    image: image4,
    mediaType: 'image',
    date: '03.03.2024 Sunday',
    day: 'HEALTHY FOOD, ART, YOGA...',
    textColor: '#7C6DE7',
    route: "/birthdance/day-4",
  },
  {
    title: "Birthdance47",
    subtitle: 'EDHE the LAST DANCE with Family',
    content: "Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    image: image5,
    mediaType: 'image',
    date: '03.03.2024 Sunday',
    day: 'HEALTHY FOOD, ART, YOGA...',
    textColor: '#7C6DE7',
    route: "/birthdance/day-5",
  },
  {
    title: "Birthdance47",
    subtitle: 'EDHE the LAST DANCE with Family',
    content: "Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    image: image6,
    mediaType: 'video',
    date: '03.03.2024 Sunday',
    day: 'HEALTHY FOOD, ART, YOGA...',
    textColor: '#7C6DE7',
    route: "/birthdance/day-6",
  },
];

export { birth2025 };
